import { useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { peekListFetchOffset } from './listViewStorage';
import { useListKeepAlive } from './ListKeepAliveContext';
import { useListScrollRestore } from './useListScrollRestore';

export function useListPageNavigation({
    id,
    pathname = '',
    displayMode = 'list',
    itemSizes = { grid: 350, list: 70 },
    columns = 1,
    resetOnFilters,
    resetOnSort,
    ready,
} = {}) {
    const location = useLocation();
    const keepAlive = useListKeepAlive();
    const resolvedPathname = keepAlive?.listPath || pathname || location.pathname;
    const itemSize = displayMode === 'grid' ? (itemSizes.grid ?? 350) : (itemSizes.list ?? 70);
    const scrollRef = useRef(null);
    const [offset, setOffset] = useState(() => peekListFetchOffset({
        id,
        pathname: resolvedPathname,
        displayMode,
        itemSize,
        columns,
    }));

    const { persistScroll, initialScrollOffset } = useListScrollRestore({
        id,
        pathname: resolvedPathname,
        displayMode,
        itemSize,
        columns,
        scrollRef,
        setOffset,
        ready,
        resetOnFilters,
        resetOnSort,
    });

    const navigationValue = useMemo(
        () => ({ persistScroll, initialScrollOffset }),
        [persistScroll, initialScrollOffset],
    );

    return {
        scrollRef,
        offset,
        setOffset,
        initialScrollOffset,
        navigationValue,
    };
}
